import React from "react";
import { InfoChip } from "../../../../../../../designSystem/Chip";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";

type IndicatorListProps = {
    indicators: string[]
}

export function IndicatorList(props: IndicatorListProps): JSX.Element {
    return (
        <Flex gap={8} style={{flexWrap:'wrap'}}>
            {props.indicators.map((v, i) =>
                <InfoChip key={i}>{v}</InfoChip>
            )}
        </Flex>
    );
}